module.exports = "/images/vendor/flag-icon-css/flags/1x1/fi.svg?b48413bec5778656a773aab237f031a4";